export const WEBHOOK_EVENT = {
  CUSTOMER_CREATED: 'customer.created',
  CUSTOMER_UPDATED: 'customer.updated',
  PAYMENT_CREATED: 'payment.created',
  PAYMENT_PAID: 'payment.paid',
  BOOKING_CREATED: 'booking.created',
  BOOKING_PAID: 'booking.paid',
  // SUBSCRIPTION_CREATED: 'subscription.created',
  // SUBSCRIPTION_ACTIVE: 'subscription.active',
  TICKET_CREATED: 'ticket.created',
};

export const WEBHOOK_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  FAILED: 'failed',
};

// Legacy support - can be removed when no longer used
export const WEBHOOK_EVENT_TYPES = {
  CONVERSION: 'conversion',
};
